module.exports = __webpack_public_path__ + "static/assets/2d24a289beac8fe221ce132aac88a320.svg";